import { Box, CircularProgress, Divider } from "@mui/material";
import React, { useEffect } from "react";
import { PageHeading } from "../../../components/PageHeading";
import { SectionTitle } from "../../../components/SectionTitle";
import ShowcaseBox from "../../../components/ShowcaseBox";
import { ReactComponent as LoyaltyIcon } from "../../../assets/icons/loyalty.svg";
import { ReactComponent as AGIIcon } from "../../../assets/icons/agi2.svg";
import { ReactComponent as ReferralsIcon } from "../../../assets/icons/referrals.svg";
import { ReactComponent as GalxeIcon } from "../../../assets/icons/galxe.svg";
import { ReactComponent as EngageIcon } from "../../../assets/icons/Engagement_Icon.svg";
import Container from "../../../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { getLoyaltyStats } from "../../../redux/slices/loyalty";
import { ReactComponent as BetaHighlightedIcon } from "../../../assets/icons/beta_highlighted_large.svg";
import QAItem from "./QAItem";
import { LOYALTY_FAQS, LOYALTY_PROGRAM_NOTICE } from "../../../constants/dashboardContent";

const IS_SHOW_COMING_SOON = false

function ComingSoonTips () {
  return (
    <Box sx={{
      pt: { xxs: "20px", sm: "60px" },
      fontFamily: "Chakra Petch, sans-serif",
    }}>
      <Box sx={{
        fontWeight: 500,
        fontSize: { xxs: 14, sm: 20 },
        marginBottom: { xxs: "4px", sm: "8px" }
      }}>Coming Soon</Box>
      <Box sx={{
        fontSize: { xxs: 12, sm: 16 },
        opacity: 0.5
      }}>
      {LOYALTY_PROGRAM_NOTICE}
      </Box>
    </Box>
  )
}

const showcaseContainerSx = {
  display: "flex",
  flexFlow: { xxs: "column nowrap", md: "row nowrap" },
  gap: { md: 0.625 }
};

const LoyaltyProgram = () => {
  const dispatch = useDispatch();
  const {
    isLoading,
    stats
  } = useSelector((state) => state.loyalty);

  useEffect(() => {
    dispatch(getLoyaltyStats());
  }, [dispatch]);

  if (IS_SHOW_COMING_SOON) {
    return (
      <Container>
        <PageHeading title="Loyalty Program" subtitle="Record your growth in Delysium ecosystem" />
        <ComingSoonTips />
      </Container>
    )
  }

  return (
    <Container>
      <PageHeading
        Label={() => <BetaHighlightedIcon style={{ marginBottom: "7px" }} />}
        title="Loyalty Program"
        subtitle="Record your growth in Delysium ecosystem"
      />

      {isLoading ? (
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            mt: 7.5
          }}>
          <CircularProgress color="primary" size={30} />
        </Box>
      ) : (
        <>
          <SectionTitle label="Loyalty Score" />
          <Box display="flex" flexDirection="column" flexWrap="wrap">
            <Box sx={showcaseContainerSx}>
              <ShowcaseBox
                Icon={LoyaltyIcon}
                title="Your Loyalty Score"
                hideSubtitle
                amount={stats.points_total}
              />
            </Box>
            <Box sx={showcaseContainerSx}>
              <ShowcaseBox
                hideSubtitle
                Icon={ReferralsIcon}
                title="From DMA Holding / Referral"
                amount={stats.points_dma}
                amountColor="textPrimary"
              />
              <ShowcaseBox
                Icon={AGIIcon}
                title={`From LP Staking`}
                hideSubtitle
                amount={stats.points_lp}
                amountColor="textPrimary"
                dataAugmentedUI="tr-clip bl-clip border"
              />
            </Box>
            <Box sx={showcaseContainerSx}>
              <ShowcaseBox
                noValueFormatting
                Icon={EngageIcon}
                title="Engagement Score"
                hideSubtitle
                amount={stats.points_static}
                amountColor="textPrimary"
              />

              <ShowcaseBox
                noValueFormatting
                Icon={GalxeIcon}
                title="From Galxe OAT Holding"
                hideSubtitle
                amount={stats.points_oat}
                amountColor="textPrimary"
              />
            </Box>
            <ShowcaseBox
                Icon={AGIIcon}
                title={`From AGI Holding`}
                hideSubtitle
                amount={parseFloat(stats.points_agi)}
                amountColor="textPrimary"
                dataAugmentedUI="tr-clip bl-clip border"
              />
          </Box>

          {LOYALTY_FAQS.length > 0 && (
            <>
              <SectionTitle label="FAQS" sx={{ mb: { xxs: 0.5, md: 1 } }} />
              <Divider sx={{ borderColor: "#45494C", mt: 3, mb: 3.5 }} />
            </>
          )}
          {LOYALTY_FAQS.map(({ title, content }, i) => (
            <QAItem question={title} answer={content} id={`loyalty-faq-${i}`} key={title} />
          ))}
        </>
      )}
    </Container>
  );
};

export default LoyaltyProgram;
